/**
 * Returns true when the current URL is a genuine Keycloak OIDC
 * authorization-code callback.
 *
 * A real callback carries three hash params:
 *   - `code`  — the authorization code to exchange for tokens
 *   - `state` — the CSRF/PKCE state value keycloak-js stored before redirect
 *   - `iss`   — the issuer, added by Keycloak ≥ 22 for extra validation
 *
 * Matching `iss` against the configured realm URL means a stray `code=` in
 * the hash (e.g. a manually constructed URL) does not trigger this path.
 *
 * @param {{ keycloakUrl: string, keycloakRealm: string }} config
 */
export function isOidcCallback(config) {
  const params = new URLSearchParams(window.location.hash.slice(1))
  const expectedIssuer = `${config.keycloakUrl.replace(/\/$/, '')}/realms/${config.keycloakRealm}`
  return Boolean(
    params.get('code') &&
    params.get('state') &&
    params.get('iss') === expectedIssuer
  )
}
